// Het logboek van de widget. (WI15)
//
// Er stonden 236 console-aanroepen in de bron: 199 keer console.error, 20 keer console.log, 12 keer
// console.info en 5 keer console.warn. Die schrijven allemaal in de console van de gast.
//
// Waarom dat weg moet:
//
//   1. Een gast hoort niets in zijn console te zien. Het is niet van hem, hij kan er niets mee, en
//      het staat er alsof er iets mis is.
//   2. Er staan gegevens in. Een console.error die een heel antwoord meeschrijft, zet naam,
//      e-mailadres en telefoonnummer van de gast in zijn eigen console -- en in elke opname die
//      iemand van dat scherm maakt. Dat is dezelfde reden waarom WI7 de Sentry-opname heeft
//      afgeschermd.
//   3. Wat er echt toe doet, gaat al naar Sentry: de onderschepper van axios stuurt elke mislukte
//      aanroep door met de status en het adres erbij (WI5), en de ErrorBoundary vangt de rest.
//      Een console.error ernaast voegt niets toe.
//
// Wat er voor in de plaats komt: dit bestand. Op een werkplek schrijft het gewoon in de console, en
// bij een gast doet het niets. Wie iets wil zien wat wél bij een gast hoort te landen, gebruikt
// Sentry -- daar is het voor.
import { isOntwikkeling } from '../instellingen';

/** Iets wat je tijdens het bouwen wilt zien. */
export function meld(...wat) {
    if (!isOntwikkeling) return;

    // eslint-disable-next-line no-console
    console.log(...wat);
}

/** Iets wat niet klopt maar wel doorgaat. */
export function waarschuw(...wat) {
    if (!isOntwikkeling) return;

    // eslint-disable-next-line no-console
    console.warn(...wat);
}

/**
 * Iets wat is misgegaan.
 *
 * Ook deze schrijft alleen op een werkplek. Een echte fout hoort in Sentry en niet in de console
 * van de gast; dat gebeurt al in de onderschepper van axios en in de ErrorBoundary.
 */
export function fout(...wat) {
    if (!isOntwikkeling) return;

    // eslint-disable-next-line no-console
    console.error(...wat);
}
